module.exports = __FOREMAN_VENDOR__NUMBER_HELPERS__;